export default {
  name: "Producten"
}
